// extracted by mini-css-extract-plugin
export var md = "768px";
export var modalContainer = "SwapConfirmationModal_modalContainer__ybD6k";
export var modalOverlay = "SwapConfirmationModal_modalOverlay__srp8g";
export var modalWrapper = "SwapConfirmationModal_modalWrapper__-NV-g";
export var shared = "'../../shared.module.css'";